.cls-2 {
  fill: #fff;
  object-fit: contain;
}
#Rectangle_5527 {
  fill: none;
}
